<template>
  <u-expansion-panels
    eager
    @update:model-value="handleUpdateModel"
  >
    <u-expansion-panel
      v-for="panel in blok.body"
      :key="panel._uid"
      :title="panel.title"
    >
      <u-content :document="panel.description" />
    </u-expansion-panel>
  </u-expansion-panels>
</template>

<script setup lang="ts">
import { isUndefined } from 'lodash-es'
import type { FaqStoryblok } from '#shared/types/storyblok-component-types'

const { trackEvent } = useGtm()
const { gtm, blok } = defineProps<{
  blok: FaqStoryblok
  gtm?: Partial<{
    event: string
    category: string
    action: string
    label: string
  }>
}>()

function handleUpdateModel(value: number) {
  if (!isUndefined(value) && !!gtm) {
    trackEvent({
      event: gtm.event,
      eventCategory: gtm.category,
      eventAction: gtm.action,
      eventLabel: `${gtm.label}_${value + 1}`,
    })
  }
}
</script>
